import actions from "./actions";

const initState = {
  idToken: null,
  token: null,
  user: {},
  loading: false,
  errorMessage: null,
  response: null,
  status: null,
  email: null,
  passwordChanged: false,
  loginData: {},
};

export default function authReducer(state = initState, action) {
  switch (action.type) {
    case actions.LOGIN_REQUESTED:
      return {
        ...state,
        loading: true,
        error: "",
        response: null,
        loginData: null,
        user: null,
      };
    case actions.LOGIN_SUCCEEDED:
      return {
        ...state,
        user: action.user.user_info,
        token: action.user.token,
        loading: false,
      };
    case actions.LOGIN_FAILED: {
      return {
        ...state,
        loading: false,
        errorMessage: action.error,
        response: null,
        loginData: action.loginData,
      };
    }
    case actions.LOGOUT:
      return initState;

    case actions.FORGOT_PASSWORD_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case actions.FORGOT_PASSWORD_SUCCESSDED:
      return {
        ...state,
        loading: false,
        response: action.response.data,
        errorMessage: null,
        email: action.email,
      };
    case actions.FORGOT_PASSWORD_FAILED: {
      return {
        ...state,
        loading: false,
        errorMessage: action.error,
        response: null,
      };
    }

    case actions.CHECK_CODE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case actions.CHECK_CODE_SUCCESSDED:
      return {
        ...state,
        loading: false,
        response: action.response.data,
        errorMessage: null,
        email: action.email,
      };
    case actions.CHECK_CODE_FAILED: {
      return {
        ...state,
        loading: false,
        errorMessage: action.error,
        response: null,
      };
    }
    case actions.RESET_PASSWORD_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case actions.RESET_PASSWORD_SUCCESSDED:
      return {
        ...state,
        loading: false,
        response: action.response.data,
        errorMessage: null,
        passwordChanged: true,
      };
    case actions.RESET_PASSWORD_FAILED: {
      return {
        ...state,
        loading: false,
        errorMessage: action.error,
        response: null,
      };
    }
    default:
      return state;
  }
}
